import Vue from 'vue'
import App from './App.vue'
// import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import mainMixin from './mixins/Main'
Vue.mixin(mainMixin)

import VueTruncate from 'vue-truncate-filter'
Vue.use(VueTruncate)

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
Vue.component('PerfectScrollbar', PerfectScrollbar)

Vue.config.productionTip = false

import './../vee-validate.js'

import moment from 'moment'
Vue.filter('DateFormat', function (value, format) {
  if (value) {
    return moment(value).format(format)
  } else {
    return '-'
  }
})

new Vue({
  // router,
  store,
  vuetify,
  render: function (h) {
    let props = {}
    let zchatpluginDom = document.getElementById('z-chat-plugin')
    if (zchatpluginDom) {
      if (zchatpluginDom.getAttribute('data-api-key'))
        props['apiKey'] = zchatpluginDom.getAttribute('data-api-key')
    }
    return h(App, { props: props })
  }
}).$mount('#z-chat-plugin')
